/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorallfundvehicles4Inputs */

const en_settings_collaborators_invitecollaboratorallfundvehicles4 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorallfundvehicles4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All fund vehicles`)
};

/**
* | output |
* | --- |
* | "All fund vehicles" |
*
* @param {Settings_Collaborators_Invitecollaboratorallfundvehicles4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorallfundvehicles4 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorallfundvehicles4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorallfundvehicles4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorallfundvehicles4(inputs)
});
export { settings_collaborators_invitecollaboratorallfundvehicles4 as "settings_collaborators_inviteCollaboratorAllFundVehicles" }